function findUsedGcmConsentTypes(services) {
    return [
        ...new Set(services.map(({ googleConsentModeConsentTypes })=>// Create copy when it comes as `ObservableArray` (mobx)
            [
                ...googleConsentModeConsentTypes
            ]).flat())
    ];
}
export { findUsedGcmConsentTypes };
